import { ApiKey } from '@xeetr/types/models'

import ApiService from './common/API.service'


interface GenerateApiKeyRequest {
  description: string
  permissions: string[]
}

interface GenerateApiKeyResponse {
  id: string
  apiKey: string
  description: string
  permissions: string[]
  issuedAt: string
}

interface UpdateApiKeyRequest {
  permissions: string[]
}

export class ApiKeyService extends ApiService {
  getApiKeys = async (): Promise<{ apiKeys: ApiKey[] }> => {
    const { data } = await this.get<{ apiKeys: ApiKey[] }>(this.buildCommonUrl('api-key'))
    return data
  }

  generateApiKey = async (
    description: string,
    permissions?: string[]
  ): Promise<GenerateApiKeyResponse> => {
    const { data } = await this.post<GenerateApiKeyRequest, GenerateApiKeyResponse>(
      this.buildCommonUrl('api-key'),
      {
        description,
        permissions: permissions || ['read:bookings'],
      }
    )
    return data
  }

  updateApiKey = async (id: string, permissions: string[]): Promise<void> => {
    await this.put<UpdateApiKeyRequest, void>(this.buildCommonUrl(`api-key/${id}`), {
      permissions,
    })
  }

  deleteApiKey = async (id: string): Promise<void> => {
    await this.delete<void>(this.buildCommonUrl(`api-key/${id}`))
  }
}
